const isProduction = import.meta.env.MODE === 'production'
const enableActivityLogs = import.meta.env.VITE_ENABLE_ACTIVITY_LOGS === 'true'

export const createLogger = (name = 'Logger') => {
  // Detection of components related to the activity monitoring system
  const isActivityLogger =
    name &&
    (name.includes('Activity') ||
      name === 'ActivityStore' ||
      name === 'ActivityComposable')

  // Conditional verification for activity loggers
  if (isActivityLogger && !enableActivityLogs) {
    // Return of neutral functions when activity logs are disabled
    return {
      group: () => {},
      groupEnd: () => {},
      log: () => {},
      warn: () => {},
      error: console.error, // Preservation of errors for diagnostics
      info: () => {}
    }
  }

  if (isProduction) {
    // Deactivation of logs in production environment
    return {
      group: () => {},
      groupEnd: () => {},
      log: () => {},
      warn: () => {},
      error: console.error, // Preservation of errors for diagnostics
      info: () => {}
    }
  }

  // Complete implementation
  return {
    group: (...args) => console.group(`[${name}]`, ...args),
    groupEnd: () => console.groupEnd(),
    log: (...args) => console.log(`[${name}]`, ...args),
    warn: (...args) => console.warn(`[${name}]`, ...args),
    error: (...args) => console.error(`[${name}]`, ...args),
    info: (...args) => console.info(`[${name}]`, ...args)
  }
}

export const logger = createLogger()
